import { ChakraProvider } from "@chakra-ui/react";
import React , { useEffect, useState } from "react";
import NavigationMenu from "../Navigation/NavigationMenu";
import AddLeaveCategory from "./AddLeaveCategory";
import AddDocumentFormat from "./AddDocumentFormat";
import "./Add.css";
import axios from "axios";

const AddMaster = () => {
  const [departments, setDepartments] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [WorkingDepartments, setWorkingDepartments] = useState([]);
  const [positions, setPositions] = useState([]);

  useEffect(() => {
    // Fetch departments from server when component mounts
    fetchDepartments();
  }, []);

  const fetchDepartments = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_API || `${process.env.REACT_APP_BACKEND_API || 'https://kidbackend.codingindia.co.in'}`}/HumanResource/api/leavecategory/`
      );
      setDepartments(response.data);
    } catch (error) {
      console.error("Error fetching departments:", error);
      // Handle error
    }
  };


 
  useEffect(() => {
    // Fetch positions and departments from server when component mounts
    fetchPositions();
  }, []);

  const fetchPositions = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_API || `${process.env.REACT_APP_BACKEND_API || 'https://kidbackend.codingindia.co.in'}`}/HumanResource/api/positions/`
      );
      setPositions(response.data);
    } catch (error) {
      console.error("Error fetching positions:", error);
    }
  };

  const handleDataChange = () => {
    fetchDepartments();
    fetchPositions();
  };

  return (
    <>
      <NavigationMenu />
      <ChakraProvider>
        <div className="addMasterWrapper">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 col-md-12 col-lg-12">
                <div className="addHrPolicyHeading">
                  <h1>Add</h1>
                  <p>
                    Click on Create button to add the{" "}
                    <span> Documents Format, Leave Category </span>
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-md-4 col-lg-4">
              <AddLeaveCategory
                  departments={departments}
                  onDataChange={handleDataChange}
                />
              </div>
              <div className="col-12 col-md-4 col-lg-4">
              <AddDocumentFormat
                  departments={departments}
                  onDataChange={handleDataChange}
                />
              </div>
              <div className="col-12 col-md-4 col-lg-4">
             
              </div>
            </div>
          </div>
        </div>
      </ChakraProvider>
    </>
  );
};

export default AddMaster;
